import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertCriterionCollection } from '@app/shared/model/classes/alert-criterion-collection';
import {
  AlertsService,
  AlertCategory,
  NotificationChannel,
  NotificationFrequency,
  AlertCriterion,
  AlertSettings,
  AlertCriterionKey
} from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { CreateAlertSuccess } from '@app/+catalog/store/actions/catalog.action';

@Component({
  selector: 'vc-alerts-modal',
  templateUrl: './alerts-modal.component.html',
  styleUrls: ['./alerts-modal.component.scss']
})
export class AlertsModalComponent implements OnInit {
  public articlesLimitPerDay = 30; // Value that limit the number of choice in the alert frequency
  public nbArticles = 0;
  public tags: String[];
  public currentFacetRefinement: {}[];
  public listAlertFrequency;
  public submittingAlert = false;

  public showSuccess = false;
  public showAlreadyExists = false;
  public showErrors = false;
  public errorMessage: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datas: any,
    private alertsService: AlertsService,
    private dialogRef: MatDialogRef<AlertsModalComponent>,
    private store: Store<IAppState>
  ) {}

  ngOnInit() {
    this.currentFacetRefinement = this.datas.currentFacetRefinement;

    this.alertsService
      .getProductsAverageMatching(
        this.currentFacetRefinement['searchQuery'],
        this.currentFacetRefinement['idUniverse'],
        this.currentFacetRefinement['idBrand'],
        this.currentFacetRefinement['idMaterials'],
        this.currentFacetRefinement['idPattern'],
        this.currentFacetRefinement['idColors'],
        this.currentFacetRefinement['idCondition'],
        this.currentFacetRefinement['idCategory'],
        this.currentFacetRefinement['idSubcategory'],
        this.currentFacetRefinement['idSize'],
        this.currentFacetRefinement['idWatchMechanism'],
        this.currentFacetRefinement['idDiscount']
      )
      .subscribe(
        res => {
          // Prevent error
          if (res.data && res.data.averageProductsPerDay) {
            this.nbArticles = Number(res.data.averageProductsPerDay);
          }
          if (this.nbArticles > this.articlesLimitPerDay) {
            // Set `eachDay` by default to prevent error when there is only one choice
            this.listAlertFrequency = 'eachDay';
          }
        },
        err => {
          // Shadow func for TSLINT
        }
      );
  }

  public createAlert() {
    this.submittingAlert = true;
    const alertCategory: AlertCategory = 'newProduct';
    const channel: Array<NotificationChannel> = [];
    let frequency: NotificationFrequency;

    const criterions: AlertCriterionCollection = new AlertCriterionCollection();
    Object.keys(this.currentFacetRefinement).map(criterionKey => {
      if (this.currentFacetRefinement[criterionKey] && this.currentFacetRefinement[criterionKey].length) {
        this.currentFacetRefinement[criterionKey].map(criterionValue => {
          const criterion: AlertCriterion = {
            key: criterionKey as AlertCriterionKey,
            value: [criterionValue as string]
          };
          criterions.addCriterion(criterion);
        });
      }
    });

    const criteria: Array<AlertCriterion> = criterions.getList();

    switch (this.listAlertFrequency) {
      case 'eachDay':
        frequency = 'daily';
        channel.push('email');
        break;

      case 'emailAndPush':
        frequency = 'realtime';
        channel.push('email', 'push');
        break;

      case 'email':
        frequency = 'realtime';
        channel.push('email');
        break;

      case 'push':
        frequency = 'realtime';
        channel.push('push');
        break;

      default:
        frequency = 'daily';
        channel.push('email');
    }

    // Stock
    criteria.push({
      key: 'stock',
      value: this.datas.stock
    });

    const data: AlertSettings = {
      category: alertCategory,
      channels: channel,
      frequency: frequency,
      criteria: criteria
    };

    this.alertsService.createAlert(data, 'response').subscribe(
      res => {
        this.submittingAlert = false;
        this.showSuccess = false;
        this.showAlreadyExists = false;
        this.showErrors = false;
        if (res.status === 201) {
          this.showSuccess = true;
          // payload empty for CreateAlertSuccess.
          // We wait SEO tracking for alert on Catalog Page.
          this.store.dispatch(new CreateAlertSuccess({}));
          // When Success show message and then close modal
          setTimeout(() => {
            this.dialogRef.close();
          }, 1500);
        }
      },
      error => {
        this.submittingAlert = false;
        this.showSuccess = false;
        this.showAlreadyExists = false;
        this.showErrors = false;

        if (error.status === 500) {
          this.showErrors = true;
          this.errorMessage = error.statusText;
        } else if (error.status === 400 || error.status === 409) {
          this.showAlreadyExists = true;
        } else {
          this.showErrors = true;
          if (error.error && error.error.errors && error.error.errors.detail) {
            this.errorMessage = error.error.errors.detail;
          }
        }
      }
    );
  }
}
